import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getExcludedOrganisations,
  addExcludedOrganisation,
  removeExcludedOrganisation,
} from '../../../../apis/clinics/requests';
import { Organisation } from '../../../../types/organisation';
import { useSnackbar } from 'notistack';

interface UseExcludedOrganisationsReturn {
  organisations: Organisation[];
  totalCount: number;
  isLoading: boolean;
  addOrganisation: (organisationId: string) => Promise<Organisation>;
  removeOrganisation: (organisationId: string) => Promise<void>;
}

const useExcludedOrganisations = (clinicId: string, page: number, limit: number): UseExcludedOrganisationsReturn => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading } = useQuery(
    ['excludedOrganisations', clinicId, page, limit],
    () => getExcludedOrganisations(clinicId, { page, limit }),
  );

  const addMutation = useMutation(
    (organisationId: string) => addExcludedOrganisation(clinicId, organisationId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['excludedOrganisations', clinicId]);
        enqueueSnackbar(`Organisation has been added to excluded organisations`, { variant: 'success' });
      }
    }
  );

  const removeMutation = useMutation(
    (organisationId: string) => removeExcludedOrganisation(clinicId, organisationId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['excludedOrganisations', clinicId]);
        enqueueSnackbar('Organisation has been removed from excluded organisations', { variant: 'success' });
      }
    }
  );

  console.log('data', data);

  return {
    organisations: data?.data || [],
    totalCount: data?.pagination?.total || 0,
    isLoading,
    addOrganisation: addMutation.mutateAsync,
    removeOrganisation: removeMutation.mutateAsync
  };
};

export default useExcludedOrganisations; 
